import { clamp, num, round2 } from './round';
import type { DiscountMode, DocTotals } from './types';

export function calcLine(params: {
  qty: any;
  price: any;
  vatRate: any;
  discountRate: any;
  discountAmount: any;
  mode: DiscountMode;
}) {
  const qty = num(params.qty);
  const price = num(params.price);
  const vatRate = clamp(num(params.vatRate), 0, 100);

  const baseBeforeDiscount = qty * price;

  let discountUsed = 0;

  if (params.mode === 'AMOUNT') {
    discountUsed = clamp(num(params.discountAmount), 0, baseBeforeDiscount);
    // ❌ لا نلمس discountRate
  } else {
    const rate = clamp(num(params.discountRate), 0, 100);
    discountUsed = clamp((baseBeforeDiscount * rate) / 100, 0, baseBeforeDiscount);
    // ❌ لا نلمس discountAmount
  }

  const baseAfterDiscount = Math.max(0, baseBeforeDiscount - discountUsed);
  const vatAmount = (baseAfterDiscount * vatRate) / 100;

  return {
    baseBeforeDiscount: round2(baseBeforeDiscount),
    discountUsedAmount: round2(discountUsed),
    baseAfterDiscount: round2(baseAfterDiscount),
    vatRate: round2(vatRate),
    vatAmount: round2(vatAmount)
  };
}




export function calcDocumentTotals(params: {
  lines: any[];
  headerDiscountRate: any;
  headerDiscountAmount: any;
  headerMode: DiscountMode;
  getLineMode: (line: any, index: number) => DiscountMode;
}): DocTotals & { grossTotal: number } {
  const { lines, headerDiscountRate, headerDiscountAmount, headerMode, getLineMode } = params;

  // 1) احسب السطور (خصم السطر يؤثر على VAT)
  const lineResults = lines.map((l, i) => {
    const mode = getLineMode(l, i);
    return calcLine({
      qty: l?.qty,
      price: l?.price,
      vatRate: l?.vatRate,
      discountRate: l?.discountRate,
      discountAmount: l?.discountAmount,
      mode
    });
  });

  const linesSubtotal = round2(lineResults.reduce((s, x) => s + x.baseAfterDiscount, 0));
  const vatTotal = round2(lineResults.reduce((s, x) => s + x.vatAmount, 0));

  // ✅ الإجمالي شامل الضريبة قبل خصم الهيدر
  const grossTotal = round2(linesSubtotal + vatTotal);

  // 2) خصم الهيدر (After-Tax) => يُطرح من grossTotal مباشرة
  const rateIn = clamp(num(headerDiscountRate), 0, 100);
  const amtIn = num(headerDiscountAmount);

  let headerDiscountUsedAmount = headerMode === 'RATE' ? (grossTotal * rateIn) / 100 : amtIn;
  headerDiscountUsedAmount = round2(clamp(headerDiscountUsedAmount, 0, grossTotal));

  // ✅ الصافي النهائي (VAT لا يتأثر)
  const netTotal = round2(Math.max(0, grossTotal - headerDiscountUsedAmount));

  return {
    linesSubtotal,
    headerDiscountUsedAmount,
    vatTotal,
    netTotal,
    grossTotal
  };
}

 



 
// import Decimal from 'decimal.js';
// import { clamp, num, round2 } from './round';
// import type { DiscountMode, DocTotals } from './types';


// const trunc = (v: Decimal.Value, decimals = 2) =>
//   new Decimal(v ?? 0).toDecimalPlaces(decimals, Decimal.ROUND_DOWN).toNumber(); // ✅ انتبه للأقواس ()

// export function calcLine(params: {
//   qty: any;
//   price: any;
//   vatRate: any;
//   discountRate: any;
//   discountAmount: any;
//   mode: DiscountMode;
// }) {
//   const qty = num(params.qty);
//   const price = num(params.price);
//   const vatRate = clamp(num(params.vatRate), 0, 100);

//   const baseBeforeDiscount = qty * price;

//   let discountUsed = 0;

//   if (params.mode === 'AMOUNT') {
//     discountUsed = clamp(num(params.discountAmount), 0, baseBeforeDiscount);
//     // ❌ لا نلمس discountRate
//   } else {
//     const rate = clamp(num(params.discountRate), 0, 100);
//     discountUsed = clamp((baseBeforeDiscount * rate) / 100, 0, baseBeforeDiscount);
//     // ❌ لا نلمس discountAmount
//   }

//   const baseAfterDiscount = Math.max(0, baseBeforeDiscount - discountUsed);


//     var unitP = round2( baseAfterDiscount / qty);
//     const Vat = trunc(( unitP *vatRate ) /100 , 2);
//     const vatAmount = round2(Vat * qty);


//   // const vatAmount = (baseAfterDiscount * vatRate) / 100;

//   return {
//     baseBeforeDiscount: round2(baseBeforeDiscount),
//     discountUsedAmount: round2(discountUsed),
//     baseAfterDiscount: round2(baseAfterDiscount),
//     vatRate: round2(vatRate),
//     vatAmount: round2(vatAmount)
//   };
// }




// export function calcDocumentTotals(params: {
//   lines: any[];
//   headerDiscountRate: any;
//   headerDiscountAmount: any;
//   headerMode: DiscountMode;
//   getLineMode: (line: any, index: number) => DiscountMode;
// }): DocTotals & { grossTotal: number } {
//   const { lines, headerDiscountRate, headerDiscountAmount, headerMode, getLineMode } = params;

//   // 1) احسب السطور (خصم السطر يؤثر على VAT)
//   const lineResults = lines.map((l, i) => {
//     const mode = getLineMode(l, i);
//     return calcLine({
//       qty: l?.qty,
//       price: l?.price,
//       vatRate: l?.vatRate,
//       discountRate: l?.discountRate,
//       discountAmount: l?.discountAmount,
//       mode
//     });
//   });

//   const linesSubtotal = round2(lineResults.reduce((s, x) => s + x.baseAfterDiscount, 0));
//   const vatTotal = round2(lineResults.reduce((s, x) => s + x.vatAmount, 0));

//   // ✅ الإجمالي شامل الضريبة قبل خصم الهيدر
//   const grossTotal = round2(linesSubtotal + vatTotal);

//   // 2) خصم الهيدر (After-Tax) => يُطرح من grossTotal مباشرة
//   const rateIn = clamp(num(headerDiscountRate), 0, 100);
//   const amtIn = num(headerDiscountAmount);

//   let headerDiscountUsedAmount = headerMode === 'RATE' ? (grossTotal * rateIn) / 100 : amtIn;
//   headerDiscountUsedAmount = round2(clamp(headerDiscountUsedAmount, 0, grossTotal));

//   // ✅ الصافي النهائي (VAT لا يتأثر)
//   const netTotal = round2(Math.max(0, grossTotal - headerDiscountUsedAmount));

//   return {
//     linesSubtotal,
//     headerDiscountUsedAmount,
//     vatTotal,
//     netTotal,
//     grossTotal
//   };
// }

 


 